import {
  flowIdBikmoContractFlow,
  flowIdBikmoOfferFlow,
  flowIdVillasureContractFlow,
  flowIdVillasureOfferFlow,
  flowIdPiaBoatContractFlow,
  flowIdPiaBoatOfferFlow,
  flowIdRiskAnalysisNL,
  flowIdDeMotoVerzekering,
  flowIdCompanyScanNL,
  flowIdCyclingVlaanderenContractFlowId,
  flowIdCyclingVlaanderenOfferFlowId,
  flowIdCitizinsTravel,
  flowIdCitizinsTravelContract,
  flowIdCitizinsCarAruba,
  flowIdCitizinsCarArubaContract,
  flowIdCitizinsCarCuracao,
  flowIdCitizinsCarCuracaoContract,
  flowIdCitizinsMedicalAruba,
  flowIdCitizinsMedicalCuracao,
} from '../constants/flowIds';
import useLanguageOptions, {
  allLanguageOptions,
} from '../../../common/src/hooks/useLanguageOptions';
import { useFlowInfo } from '../api/getFlowInfo';

interface UseFlowsLanguageOptions {
  label: string;
  value: string;
}

const useFlowsLanguageOptions = (flowId: string): UseFlowsLanguageOptions[] => {
  const { data: flowInfo } = useFlowInfo(flowId);
  const supportedLanguages = flowInfo?.supported_languages;
  const options = useLanguageOptions();

  /** Managed from Backend */

  if (supportedLanguages?.length) {
    // Only one language is allowed, there shouldn't be options
    if (supportedLanguages?.length === 1) return [];

    return allLanguageOptions.filter(({ value }) =>
      supportedLanguages.includes(value),
    );
  }

  /** Managed from frontend (fallback/old way) */

  if (
    [
      flowIdBikmoContractFlow,
      flowIdBikmoOfferFlow,
      flowIdCyclingVlaanderenContractFlowId,
      flowIdCyclingVlaanderenOfferFlowId,
    ].includes(flowId)
  )
    return [
      {
        value: 'nl',
        label: 'Nederlands',
      },
      {
        value: 'fr',
        label: 'Français',
      },
    ];

  if ([flowIdRiskAnalysisNL, flowIdCompanyScanNL].includes(flowId))
    return [
      {
        value: 'nl',
        label: 'Nederlands',
      },
      {
        value: 'en',
        label: 'English',
      },
    ];

  if (
    [
      flowIdCitizinsTravel,
      flowIdCitizinsTravelContract,
      flowIdCitizinsCarAruba,
      flowIdCitizinsCarArubaContract,
      flowIdCitizinsCarCuracao,
      flowIdCitizinsCarCuracaoContract,
      flowIdCitizinsMedicalAruba,
      flowIdCitizinsMedicalCuracao,
    ].includes(flowId)
  ) {
    return [
      {
        value: 'es',
        label: 'Español',
      },
      {
        value: 'nl',
        label: 'Nederlands',
      },
      {
        value: 'en',
        label: 'English',
      },
    ];
  }

  if (
    [
      flowIdDeMotoVerzekering,
      flowIdVillasureContractFlow,
      flowIdVillasureOfferFlow,
      flowIdPiaBoatContractFlow,
      flowIdPiaBoatOfferFlow,
    ].includes(flowId)
  )
    return [];

  return options;
};

export default useFlowsLanguageOptions;
